import { blockOnNavigationCancelLabel } from 'owa-locstrings/lib/strings/blockonnavigationcancellabel.locstring.json';
import { blockOnNavigationContinueLabel } from 'owa-locstrings/lib/strings/blockonnavigationcontinuelabel.locstring.json';
import { blockOnNavigationMessage } from 'owa-locstrings/lib/strings/blockonnavigationmessage.locstring.json';
import { blockOnNavigationTitle } from 'owa-locstrings/lib/strings/blockonnavigationtitle.locstring.json';
import loc from 'owa-localize';
import { ComposeViewState } from 'owa-mail-compose-store';

import { confirm, DialogResponse } from 'owa-confirm-dialog';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getComposeHostItemIndex, isAnyUilessAddinRunning } from 'owa-addins-core';

export function uiLessAddinIsRunning(viewState: ComposeViewState): boolean {
    return (
        isFeatureEnabled('rp-addins') &&
        isAnyUilessAddinRunning(getComposeHostItemIndex(viewState.composeId))
    );
}

export default async function blockOnNavigation(viewState: ComposeViewState): Promise<boolean> {
    if (!uiLessAddinIsRunning(viewState)) {
        return false;
    }

    const response: DialogResponse = await confirm(
        loc(blockOnNavigationTitle),
        loc(blockOnNavigationMessage),
        /* resolveImmediately? */ false,
        {
            okText: loc(blockOnNavigationContinueLabel),
            cancelText: loc(blockOnNavigationCancelLabel),
        }
    );

    return response === DialogResponse.cancel || response === DialogResponse.dismiss;
}
